var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"row"},[_c('video',{staticClass:"col-12",attrs:{"id":"mainVideo","controls":"","src":_vm.url}}),_c('div',{staticClass:"col-12",staticStyle:{"overflow":"scroll"}},[_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }